import * as tslib_1 from "tslib";
import { ElementRef, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { ExportDialogComponent } from '@core/components/export-dialog/export-dialog.component';
import { ExportDialogTypeEnum } from '@core/components/export-dialog/export-dialog.types';
import { SidenavService } from '@core/services/sidenav.service';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { merge, Subject } from 'rxjs';
import { debounceTime, switchMap, takeUntil, tap } from 'rxjs/operators';
import { DialogGroupsComponent } from './dialogs/dialog-groups.component';
import { FilterGroupsComponent } from './filter/filter-groups.component';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
import { GroupService } from './services/groups-api.service';
var GroupsComponent = /** @class */ (function () {
    function GroupsComponent(fuseTranslationLoaderService, authenticationService, progressBarService, sidebarService, sidenavService, groupsService, matDialog) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.authenticationService = authenticationService;
        this.progressBarService = progressBarService;
        this.sidebarService = sidebarService;
        this.sidenavService = sidenavService;
        this.groupsService = groupsService;
        this.matDialog = matDialog;
        this.displayedColumns = ['name', 'description', 'createdAt', 'edit'];
        this.groupDetailSidebarName = 'groupDetail';
        this.groups = [];
        this.filtered = false;
        this.loading = true;
        this.groupsReload = new Subject();
        this.subscriptions = new Subject();
        this.hasEditGroupPermission = this.authenticationService.hasPermission('groups-edit');
        this.hasCreateGroupPermission = this.authenticationService.hasPermission('groups-create');
        this.hasCreateExportPermission = this.authenticationService.hasPermission('exports-create');
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    GroupsComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this.loading = true;
                this.sort.active = 'name';
                this.sort.direction = 'asc';
                merge(this.sort.sortChange, this.paginator.page, this.filterGroupsComponent.filterChanged.pipe(tap(function () { return _this.paginator.firstPage(); })), this.groupsReload).pipe(debounceTime(500), takeUntil(this.subscriptions), switchMap(function () {
                    _this.progressBarService.show();
                    _this.sort.direction = _this.sort.direction || 'asc';
                    var options = {
                        orderBy: _this.sort.active + "_" + _this.sort.direction,
                        offset: _this.paginator.pageIndex * _this.paginator.pageSize,
                        limit: _this.paginator.pageSize
                    };
                    _this.loading = true;
                    return _this.groupsService.loadData({ where: _this.filterGroupsComponent.filterChanged.value, options: options });
                }))
                    .subscribe(function (result) {
                    _this.progressBarService.hide();
                    _this.datatable.nativeElement.scrollTo({ top: 0 });
                    _this.groups = result.items;
                    _this.totalCount = result.totalCount;
                    _this.filtered = result.filtered;
                    _this.loading = false;
                });
                return [2 /*return*/];
            });
        });
    };
    GroupsComponent.prototype.openExportDialog = function () {
        this.matDialog.open(ExportDialogComponent, {
            panelClass: 'export-dialog',
            autoFocus: false,
            data: {
                type: ExportDialogTypeEnum.groups,
                limit: 10000,
                total: this.totalCount,
                where: this.filterGroupsComponent.filterChanged.value
            }
        });
    };
    GroupsComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.next();
        this.subscriptions.complete();
    };
    GroupsComponent.prototype.reload = function () {
        this.groupsReload.next();
    };
    GroupsComponent.prototype.toggleFilterGroupsSidebar = function () {
        this.sidebarService.getSidebar('filterGroups').toggleOpen();
    };
    GroupsComponent.prototype.openDialog = function (groupId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var group, groupDialog;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.progressBarService.show();
                        group = {
                            description: null,
                            name: null,
                            users: [],
                            permissions: []
                        };
                        if (!groupId) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.groupsService.getGroupById(groupId)];
                    case 1:
                        group = _a.sent();
                        _a.label = 2;
                    case 2:
                        groupDialog = this.matDialog.open(DialogGroupsComponent, {
                            panelClass: ['dialog-groups'],
                            data: {
                                group: group,
                                isViewMode: groupId && !this.hasEditGroupPermission
                            }
                        });
                        this.progressBarService.hide();
                        return [4 /*yield*/, groupDialog.afterClosed()
                                .toPromise()
                                .then(function (reload) {
                                if (reload) {
                                    _this.reload();
                                }
                            })];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    GroupsComponent.prototype.clearFilters = function () {
        this.filtered = false;
        this.filterGroupsComponent.clearFilters();
    };
    return GroupsComponent;
}());
export { GroupsComponent };
